import { type FC, useMemo } from "react";
import {
  SettingsItemTemplate,
  type SettingsItemTemplateProps,
} from "@/pages/settings/__components__/SettingsItemTemplate";
import { isViewList } from "./module";
import { variousSettingsTestId } from "./const";

export interface VariousSettingsProps {
  readonly isView: {
    readonly contract: boolean | undefined;
  };
}
export const VariousSettings: FC<VariousSettingsProps> = ({ isView }) => {
  const items: SettingsItemTemplateProps["items"] = useMemo(() => isViewList(isView), [isView]);

  if (items.length === 0) {
    return null;
  }
  return <SettingsItemTemplate data-testid={variousSettingsTestId} items={items} />;
};
